import {BaseModel} from '../../_base/crud';

export class AssetClassLandAreaModel extends BaseModel {
    id: number;
    planning_status_id: number;
    planning_status_name: string;
    qos_degradation_id: number;
    qos_degradation_name: string;
    env_considerations: string;
    other_considerations: string;
    zoning_file_name: string;
    zoning_file_path: string;
    zoning_comment: string;
    heritage_file_name: string;
    heritage_file_path: string;
    heritage_comment: string;

    created_at: Date;
    updated_at: Date;

    clear() {
        this.id = null;
        this.planning_status_id = null;
        this.planning_status_name = '';
        this.qos_degradation_id = null;
        this.qos_degradation_name = null;
        this.env_considerations = null;
        this.other_considerations = null;
        this.zoning_file_name = null;
        this.zoning_comment = null;
        this.zoning_file_path = null;
        this.heritage_file_name = null;
        this.heritage_file_path = null;
        this.heritage_comment = null;

        this.created_at = new Date();
        this.updated_at = new Date();
    }
}